import PopoverHeader from '@intercom/embercom-composer/components/popover-header';
export default PopoverHeader;
